import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get an expedited passport in Peachtree City, GA?",
    a: "Through Fast Passport Center, expedited passport processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Peachtree City can take 2–6 months, especially during busy travel seasons.",
  },
  {
    q: "Where is the closest passport agency to Peachtree City for emergency passports?",
    a: "The nearest Regional Passport Agency is in Atlanta at 230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303 — about 35 miles north of Peachtree City. Regional agencies require appointments and are primarily reserved for life-or-death emergencies. Fast Passport Center can often provide a faster, more convenient option using approved courier submission for your emergency passport — no drive to Atlanta required.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center for my expedited passport?",
    a: "No — most Peachtree City and south metro Atlanta travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Peachtree City, but that's the point: you don't need one. Start your emergency passport order online, follow the checklist, and ship your documents overnight from anywhere in the Peachtree City or south metro Atlanta area.",
  },
  {
    q: "What documents do I need for an expedited passport in Peachtree City?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your expedited passport order.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants in Peachtree City typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Peachtree City and south metro Atlanta area.",
  },
  {
    q: "How long does a passport take through the post office in Peachtree City?",
    a: "Standard government processing through a Peachtree City acceptance facility (post office or county clerk) can take 2–6 months depending on government workload and the time of year. If your travel date is sooner than that, using an approved passport courier like Fast Passport Center is the safer option for your emergency passport.",
  },
  {
    q: "Is Fast Passport Center an official government agency for expedited passports?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing and emergency passport services through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Peachtree City?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do at a Peachtree City acceptance facility. Expedited processing and emergency passport options are available after the acceptance step.",
  },
  {
    q: "Can I get an emergency passport if mine is lost or stolen in Peachtree City?",
    a: "Yes. Lost or stolen passport replacements often require additional forms (including Form DS-64 to report the lost passport). We guide you through exactly what's needed and help ensure the correct process is followed to avoid delays on your expedited replacement.",
  },
];

export default function PeachtreeCityFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span> About Expedited Passports
          </h2>
          <p className="text-gray-500 text-base">
            Everything Peachtree City, Fayetteville, Newnan, and south metro Atlanta travelers ask us most often about emergency and expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions about expedited passports? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}